import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-dialog-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dialog-footer.component.html',
  styleUrl: './dialog-footer.component.css'
})
export class DialogFooterComponent {
  @Output() nextClicked = new EventEmitter<void>();
  @Output() backClicked = new EventEmitter<void>();
  @Input() step: number;

  onNext() {
    this.nextClicked.emit();
  }

  onBack() {
    this.backClicked.emit();
  }
}
